export * from "./components/checkbox";
export * from "./components/radio";
export * from "./directives/radio-manager";
export * from "./checkbox.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/checkbox/index.js
// module id = 482
// module chunks = 0